import Vue from 'vue'
import Vuex from 'vuex'
import createPersistedState from 'vuex-persistedstate'

Vue.use(Vuex)

export default new Vuex.Store({
  plugins: [createPersistedState()],
  state: {
    userSubscription: null,
    currentOrderId: null,
    currentPaymentId: null,
    currentGiftCard: null,
    currentProductId: 'MBfoMLZTitCNmfAMAqub',
    currentSubscriptionId: 0,
    currentLanguage: { id: 'SE', name: 'Svenska' },
    availableLanguages: [
      { id: 'SE', name: 'Svenska' },
      { id: 'GB', name: 'English' },
    ],

    currentUser: {
      email: '',
      phone: '',
      country: '',
      password: '',
    },
    availableZones: [ // named by user
      'Sommarhagen',
      'Vinterhagen',
      'Skogshagen',
      'Storhagen',
      'Valackhagen',
      'Lillahagen',
    ],
    availablePayments: [
      {
        id: 'card',
        name: 'Kredit- eller bankkort',
      },
    ],
    availableSubscriptions: [1, 3, 6, 12],
    availableProducts: {},
  },
  mutations: {
    devices: (state, value) => {
      state.devices = value
    },
    setCurrentLanguage: (state, value) => (state.currentLanguage = value),
    setOrderId: (state, value) => (state.currentOrderId = value),
    setPaymentId: (state, value) => (state.currentPaymentId = value),
    setGiftCard: (state, value) => (state.currentGiftCard = value),
    setProductId: (state, value) => (state.currentProductId = value),
    setSubscriptionId: (state, value) => (state.currentSubscriptionId = value),
    setUserSubscription: (state, value) => (state.userSubscription = value),
    setCurrentUser: (state, value) => (state.currentUser = value),
    setProducts: (state, value) => (state.availableProducts = value),
  },
  getters: {
    devices: state => state.devices,
    currentLanguage: state => state.currentLanguage,
    availableLanguages: state => state.availableLanguages,
    availableProducts: state => state.availableProducts,
    availablePayments: state => state.availablePayments,
    availableSubscriptions: state => state.availableSubscriptions,
    availableZones: state => state.availableZones,
    currentUser: state => state.currentUser,
    currentProduct: state => state.availableProducts[state.currentProductId],
    currentProductId: state => state.currentProductId,
    currentSubscription: state =>
      state.availableSubscriptions[state.currentSubscriptionId],
    currentSubscriptionId: state => state.currentSubscriptionId,
    currentPaymentId: state => state.currentPaymentId,
    currentGiftCard: state => state.currentGiftCard,
    currentOrderId: state => state.currentOrderId,
    currentUserSubscription: state => state.userSubscription,
  },
  actions: {},
})
